/**
 * Page that, when visited, initiates log out
 */
import React from 'react';
import PropTypes from 'prop-types';

import LoadingPlaceholder from '../LoadingPlaceholder/LoadingPlaceholder';

const propTypes = {
  logOutHandler: PropTypes.func.isRequired,
};

const defaultProps = {};

export default class LogoutPage extends React.Component {
  componentDidMount() {
    const { logOutHandler } = this.props;
    logOutHandler();
  }

  render() {
    return <LoadingPlaceholder />;
  }
}

LogoutPage.propTypes = propTypes;
LogoutPage.defaultProps = defaultProps;
